/**
 * UI permission helpers for admin portal (auth-service JWT).
 */

export {
  getStoredPermissions,
  hasPermission,
  persistAuthSession,
  persistLegacyAuthSession,
  clearAuthSession,
  getAuthServiceUrl,
  syncAuthModeFromToken,
  isLegacyAuthMode,
} from './auth';

import { hasPermission } from './auth';

export const canViewDashboard = () => hasPermission('dashboard.view');
export const canViewPrincipals = () => hasPermission('principals.view');
export const canViewPrograms = () => hasPermission('programs.view');
export const canViewDistributors = () => hasPermission('distributors.view');
export const canViewOutlets = () => hasPermission('outlets.view');
export const canUploadVpa = () => hasPermission('vpa.upload');
export const canViewVouchers = () => hasPermission('vouchers.view');
export const canViewReports = () => hasPermission('reports.view');
export const canViewMis = () => hasPermission('mis.view');
export const canViewRecon = () => hasPermission('recon.view');
export const canViewPurposeCodes = () => hasPermission('purpose_codes.view');
export const canViewNotifications = () => hasPermission('notifications.view');
export const canManageUsers = () => hasPermission('users.manage') || hasPermission('users.view');
export const canManageRbac = () => hasPermission('rbac.manage') || hasPermission('rbac.view');
